/* nco-sample-pack.js — multi-select sample picker (C3, 2026-08).
   One POST to /cart/add.js with items[] (the trade-portal pattern); per-colour SKUs land in the
   bag. Shopify's Discount Function applies the $15 minimum for one to three colours. */
(function () {
  'use strict';
  var root = document.querySelector('[data-nco-sample-pack]');
  if (!root) return;
  var MIN = Number(root.getAttribute('data-min')) || 1;
  var MAX = Number(root.getAttribute('data-max')) || 6;
  var BASE_QTY = Number(root.getAttribute('data-base-qty')) || 3;
  var TOTALS = {};
  try { TOTALS = JSON.parse(root.getAttribute('data-totals') || '{}'); } catch (e) {}
  var S = {};
  try { S = JSON.parse((root.querySelector('[data-nco-sample-pack-strings]') || {}).textContent || '{}'); } catch (e) {}
  var inputs = Array.prototype.slice.call(root.querySelectorAll('.nco-sample-pack__input'));
  var countEl = root.querySelector('[data-nco-sample-count]');
  var hintEl = root.querySelector('[data-nco-sample-hint]');
  var shipEl = root.querySelector('[data-nco-sample-ship]');
  var selectedEl = root.querySelector('[data-nco-sample-selected]');
  var selectedListEl = root.querySelector('[data-nco-sample-selected-list]');
  var addBtn = root.querySelector('[data-nco-sample-add]');
  var busy = false;

  // colour dots: hex map published by the theme head (window.prosperDigital.colours)
  var hexes = (window.prosperDigital && window.prosperDigital.colours) || {};
  root.querySelectorAll('[data-nco-hexkey]').forEach(function (el) {
    var h = hexes[el.getAttribute('data-nco-hexkey')];
    if (h) el.style.backgroundColor = h;
  });

  // Presentment-formatted totals come from Liquid (data-totals); nothing is formatted client-side.
  function money(n) { return TOTALS[String(n)] || ''; }
  function t(key, vars) {
    var s = S[key] || '';
    Object.keys(vars || {}).forEach(function (k) { s = s.split('{{ ' + k + ' }}').join(String(vars[k])); });
    return s;
  }
  function selected() { return inputs.filter(function (i) { return i.checked; }); }
  function packId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return 'nco-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }
  function selectedName(input) { return input.getAttribute('data-colour') || input.value; }
  function renderSelected() {
    var picks = selected();
    if (!selectedEl || !selectedListEl) return;
    selectedEl.hidden = picks.length === 0;
    selectedListEl.innerHTML = '';
    picks.forEach(function (input) {
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'nco-sample-pack__selected-chip';
      remove.setAttribute('data-remove-sample', input.value);
      remove.setAttribute('aria-label', t('remove', { colour: selectedName(input) }));
      remove.textContent = selectedName(input);
      remove.addEventListener('click', function () {
        input.checked = false;
        render();
      });
      selectedListEl.appendChild(remove);
    });
  }
  function render(msg) {
    var n = selected().length;
    var total = money(n);
    if (countEl) countEl.textContent = n === 0 ? t('count_zero') : n === 1 ? t('count_one', { total: total }) : t('count_other', { count: n, total: total });
    var ok = n >= MIN && n <= MAX;
    // Free shipping appears once at least one sample is selected.
    if (shipEl) shipEl.hidden = n < MIN;
    addBtn.disabled = !ok || busy;
    addBtn.textContent = ok ? t('add', { count: n, total: total }) : t('add_disabled', { min: MIN });
    if (hintEl) {
      hintEl.textContent = msg || (
        n > 0 && n < BASE_QTY ? t('included_more', { n: BASE_QTY - n, total: money(n) }) :
        n >= MAX ? t('at_max', { max: MAX }) : ''
      );
    }
    inputs.forEach(function (i) {
      if (!i.checked) i.disabled = i.hasAttribute('data-unavailable') || n >= MAX;
      var swatch = i.closest('.nco-sample-pack__swatch');
      if (swatch) swatch.classList.toggle('is-selected', i.checked);
    });
    renderSelected();
  }
  inputs.forEach(function (i) { if (i.disabled) i.setAttribute('data-unavailable', ''); i.addEventListener('change', function () { render(); }); });

  // Basin-page sample CTAs can deep-link to the builder with one colour preselected.
  try {
    var wanted = new URLSearchParams(window.location.search).get('sample');
    if (wanted) {
      var wantedHandle = wanted.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      var initial = inputs.find(function (i) {
        return (i.getAttribute('data-colour') || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') === wantedHandle;
      });
      if (initial && !initial.disabled) initial.checked = true;
    }
  } catch (e) {}

  addBtn.addEventListener('click', function () {
    var picks = selected();
    if (picks.length < MIN || picks.length > MAX || busy) return;
    busy = true; render(t('adding'));
    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var currentPackId = packId();
    fetch(rootPath + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: picks.map(function (i) {
        return {
          id: Number(i.value),
          quantity: 1,
          properties: {
            '_nco_sample_pack': 'assorted-builder',
            '_nco_sample_count': String(picks.length),
            '_nco_base_price_qty': String(BASE_QTY),
            '_nco_pack_id': currentPackId
          }
        };
      }) })
    }).then(function (r) { if (!r.ok) throw new Error('cart/add ' + r.status); return r.json(); }).then(function () {
      busy = false;
      inputs.forEach(function (i) { i.checked = false; });
      render(t('added'));
      try { if (window.Box && window.Box.Application) window.Box.Application.broadcast('cart-open'); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('nco:sample-pack:added', { detail: { count: picks.length, colours: picks.map(function (i) { return i.getAttribute('data-colour'); }) } })); } catch (e) {}
    }).catch(function (err) {
      console.warn('sample pack add failed', err);
      busy = false; render(t('failed'));
    });
  });
  render();
})();
